import { Pipe, PipeTransform } from '@angular/core';
import { Employee } from '@generated/models';

@Pipe({
  name: 'employeeLink',
})
export class EmployeeLinkPipe implements PipeTransform {
  transform(value: Pick<Employee, 'id'>, ...args: string[]): string[] {
    return employeeLink(value, args);
  }
}

export const employeeLink = (employee: Pick<Employee, 'id'>, childRoutes: string[] = []): string[] => {
  return ['/', 'employees', employee.id, ...childRoutes];
};
